import { Trans, useTranslation } from 'react-i18next';
import { BpeAdaptorIcon } from '../../../Icons/Bits';
import DriveUnitPortControl from '../Controls/DriveUnitPortControl';
import DeviceCardWrapper from '../DeviceCardWrapper';
import { DeviceCardProps } from '../DeviceCardProps';
import { useDriveUnitPortRegistry } from '../../../../hooks/controls/useDriveUnitPortRegistry';

const BitAdapterCard = (props: DeviceCardProps) => {
  const { t } = useTranslation();
  const { portControlValue, setPortControlValue, unsupportedRawValue } = useDriveUnitPortRegistry(props, 'motor_port');

  return (
    <DeviceCardWrapper header={props.header} headerIcon={BpeAdaptorIcon} initialOpen={props.initialOpen} onDelete={props.onDelete}>
      <DriveUnitPortControl
        {...props}
        parameterName="motor_port"
        portControlValue={portControlValue}
        setPortControlValue={setPortControlValue}
        unsupportedRawValue={unsupportedRawValue}
        label={<Trans i18nKey="bitAdapterCard.adapter_port">Adapter Port</Trans>}
        labelId="bit-adapter-port-label"
        labelPopoverId="bit-adapter-port-popover"
        labelPopover={t('bitAdapterCard.adapter_port_tooltip', 'Select the drive unit port where the Bit Adapter is connected.')}
        selectId="bit-adapter-port"
        selectLabelId="select-bit-adapter-port-label"
      />
    </DeviceCardWrapper>
  );
};

export default BitAdapterCard;
